import React, { memo } from "react";

const EmptyListErrorComponent = ({ errorMessage, errorMessageImg }) => {
  return (
    <div className="text-center">
      <p className="py-3">{errorMessage}</p>
      <img
        src={errorMessageImg}
        alt="ارور"
        className="img-fluid"
        width="320"
        height="420"
      />
    </div>
  );
};

export default memo(EmptyListErrorComponent);
